import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Text from '#components/a/Text'
import Headline from '#components/a/Headline'
import AusbildungsplanHeaderModal from './AusbildungsplanHeaderModal'

function FreigebenButton(props) {
  const {freigeben} = props
  return (
    <AusbildungsplanHeaderModal
      id="kapitel_freigeben_button"
      trigger={i18n.t('kapitel_freigeben_button')}
      variant="primary"
      modifiers={['freigeben']}
      confirmCallback={freigeben}
      confirmText={i18n.t('kapitel_freigeben_button')}
    >
      <Headline modifier="article" importance={2} text={i18n.t('kapitel_freigeben_modal_header')} />
      <Text modifier="small" text={i18n.t('kapitel_freigeben_modal_text')} />
    </AusbildungsplanHeaderModal>
  )
}

FreigebenButton.propTypes = {
  freigeben: PropTypes.func.isRequired,
}

export default FreigebenButton
